export default __webpack_public_path__ + "static/media/Icon-open-account-logout-bw.7f9b36e5.svg";